'use strict';

require("./DashboardController");